export const hipotesesRetornoRealProjetoVidaSonhoTracarMetaList = [
    1,
    3,
    4,
    5,
]

export const percHipotesesRetornoRealProjetoVidaSonhoTracarMetaList = [
    '1 %',
    '3 %',
    '4 %',
    '5 %',
]

export const coresHipotesesRetornoRealList = [
    'rgba(115,148,223,255)',
    'rgba(56,115,213,255)',
    'rgba(63,92,181,255)',
    'rgba(22,47,145,255)',
]

export const coresProjetoVidaSonhoTracarMetaList = [
    'rgba(115,148,223,255)',
    'rgba(56,115,213,255)',
    'rgba(63,92,181,255)',
    'rgba(22,47,145,255)',
]